module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "searchLicense"
  }, [_c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSearchBox),
      expression: "showSearchBox"
    }],
    ref: "searchForm",
    attrs: {
      "inline": true,
      "model": _vm.searchForm,
      "rules": _vm.searchRules
    }
  }, [_c('h1', [_vm._v("Search License")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "searchType"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Please Select"
    },
    model: {
      value: (_vm.searchForm.searchType),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "searchType", $$v)
      },
      expression: "searchForm.searchType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "License ID (Outer)",
      "value": "license_id"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Customer",
      "value": "customer"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Project",
      "value": "project"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "ER Number",
      "value": "er_num",
      "formatter": _vm.arrayFormat
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "searchQuery"
    }
  }, [_c('el-input', {
    staticClass: "input-with-select",
    attrs: {
      "maxlength": "30"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onClickSearch.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.searchForm.searchQuery),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "searchQuery", $$v)
      },
      expression: "searchForm.searchQuery"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search",
      "loading": _vm.searching
    },
    on: {
      "click": function($event) {
        return _vm.onClickSearch()
      }
    },
    slot: "append"
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLicenseRecord || _vm.searching),
      expression: "showLicenseRecord || searching"
    }, {
      name: "loading",
      rawName: "v-loading",
      value: (_vm.searching),
      expression: "searching"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.licenseRecordData,
      "empty-text": "No Record Found",
      "cell-style": {
        textAlign: 'center'
      },
      "border": "",
      "header-cell-style": {
        textAlign: 'center',
        background: '#E5E7E9'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "fixed": "",
      "prop": "outerlicense",
      "label": "Outer License"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "interlicense",
      "label": "Inter License"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "er_num",
      "label": "ER Number"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "license_content",
      "label": "License Content",
      "formatter": _vm.jsonFormat
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "lic_type",
      "label": "License Type",
      "formatter": _vm.licTypeFormat
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "project",
      "label": "Project Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "direct_cus",
      "label": "Direct Customer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user_email",
      "label": "Customer Email"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "exp_date",
      "label": "Expiry Date [as UTC(+00:00)]",
      "formatter": _vm.dateFormat
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ser_exp_date",
      "label": "Service Support Expiry Date [as UTC(+00:00)]",
      "formatter": _vm.dateFormat
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "Operation",
      "empty-text": "No Record Found",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button-group', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.showLicenseRecord),
            expression: "showLicenseRecord"
          }]
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "plain": "",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              return _vm.onClickModify(scope.row)
            }
          }
        }), _vm._v(" "), (_vm.userType === 1) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "plain": "",
            "icon": "el-icon-delete"
          },
          on: {
            "click": function($event) {
              return _vm.onClickDelete(scope.row)
            }
          }
        }) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "plain": "",
            "icon": "el-icon-download",
            "loading": _vm.downloading
          },
          on: {
            "click": function($event) {
              return _vm.onClickDownload(scope.row)
            }
          }
        })], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.curPage,
      "layout": "total, prev, pager, next, jumper",
      "total": _vm.numOfData
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-611241c2","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Search.vue
// module id = GnQ0
// module chunks = 1